import { render } from "./item.vue?vue&type=template&id=7cf97927"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=7cf97927&lang=less"
script.render = render

export default script